import { createDirectUploadToCloudMutation } from "graphql/mutations/directUpload";
import { createMD5Checksum } from "utils/createFileChecksum";
import { getAppError } from "utils/error";

import { createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       THUNKS      ------------------ */
export const createDirectUpload = createAsyncThunk(
  "createDirectUpload",
  async (file: File, { rejectWithValue }) => {
    try {
      const md5Checksum = await createMD5Checksum(file);

      const { data } = await createDirectUploadToCloudMutation({
        byteSize: file.size,
        checksum: md5Checksum,
        contentType: file.type,
        filename: file.name,
      });

      if (!data) {
        throw new Error("Failed to create direct upload");
      }

      return data?.createDirectUploadToCloud.directUpload;
    } catch (err) {
      const errorCode = getAppError(err);

      return rejectWithValue(errorCode);
    }
  }
);
